import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

const TrackPage = () => {
  const navigate = useNavigate();

  return (
    <div className="font-sans text-slate-800 antialiased" style={{ backgroundColor: '#f8fafc', color: '#0f172a' }}>
      <style>{`
        :root { 
          --brand-900: #0f172a; 
          --muted: #64748b; 
        }
        body { 
          background-color: #f8fafc; 
          color: var(--brand-900); 
        }
        h1,h2,h3,h4 { 
          color: var(--brand-900); 
        }
        .rounded-image { 
          border-radius: 12px; 
        }
        .site-container { 
          max-width: 1100px; 
          margin-left: auto; 
          margin-right: auto; 
        }
      `}</style>

      <main>
        {/* Hero */}
        <section className="py-16 bg-white">
          <div className="site-container px-6">
            <div className="grid grid-cols-1 gap-y-12 md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
              <div>
                <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-4 text-slate-900">
                  Start Tracking
                </h1>
                <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                  Choose what you want to track and begin your journey of data-driven self-improvement. Monitor your health, wellness, and daily habits with precision.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <button
                    onClick={() => navigate('/gym')}
                    className="inline-flex items-center rounded-md bg-slate-900 px-8 py-3 text-white shadow hover:bg-slate-800 transition-colors"
                  >
                    Fitness
                  </button>
                  <button
                    onClick={() => navigate('/food')}
                    className="inline-flex items-center rounded-md border border-slate-300 px-8 py-3 text-slate-700 hover:bg-slate-50 transition-colors"
                  >
                    Food
                  </button>
                  <button
                    onClick={() => navigate('/sleep')}
                    className="inline-flex items-center rounded-md border border-slate-300 px-8 py-3 text-slate-700 hover:bg-slate-50 transition-colors"
                  >
                    Sleep
                  </button>
                </div>
                <div className="mt-6">
                  <button
                    onClick={() => navigate('/more')}
                    className="inline-flex items-center rounded-md border border-slate-300 px-6 py-2 text-slate-700 hover:bg-slate-50 transition-colors text-sm"
                  >
                    More Trackers →
                  </button>
                </div>
              </div>
              <div className="flex justify-center md:justify-end">
                <img
                  src="image2_1.jpg"
                  className="w-full max-w-md rounded-lg object-cover shadow-lg"
                  alt="Tracking overview"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Features / Trackers */}
        <section id="features" className="py-16">
          <div className="site-container px-6">
            <h2 className="text-2xl font-bold mb-6">Core Health Trackers</h2>
            <p className="text-slate-600 mb-8">Essential tracking tools for monitoring your health and wellness journey.</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
              <div className="p-6 bg-white rounded-lg shadow-sm">
                <h3 className="font-semibold mb-2">Fitness Tracking</h3>
                <p className="text-sm text-slate-600">Monitor workouts, track progress, and achieve your fitness goals.</p>
              </div>
              <div className="p-6 bg-white rounded-lg shadow-sm">
                <h3 className="font-semibold mb-2">Nutrition Monitoring</h3>
                <p className="text-sm text-slate-600">Log meals, count calories, and maintain a balanced diet.</p>
              </div>
              <div className="p-6 bg-white rounded-lg shadow-sm">
                <h3 className="font-semibold mb-2">Sleep Analysis</h3>
                <p className="text-sm text-slate-600">Track sleep patterns and optimize your rest for better wellness.</p>
              </div>
            </div>

            <h3 className="text-xl font-bold mb-4">Quick Access</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="p-4 bg-white rounded-lg shadow-sm">
                <h4 className="font-semibold">Fitness Tracker</h4>
                <p className="text-sm text-slate-600">Track workouts and progress</p>
              </div>
              <div className="p-4 bg-white rounded-lg shadow-sm">
                <h4 className="font-semibold">Food Tracker</h4>
                <p className="text-sm text-slate-600">Monitor nutrition and meals</p>
              </div>
              <div className="p-4 bg-white rounded-lg shadow-sm">
                <h4 className="font-semibold">Sleep Tracker</h4>
                <p className="text-sm text-slate-600">Optimize your rest patterns</p>
              </div>
            </div>
          </div>
        </section>

        {/* Visual section */}
        <section className="py-16 bg-slate-50">
          <div className="site-container px-6 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-xl font-bold mb-4">Track your progress</h3>
              <p className="text-slate-600 mb-6">See trends, insights, and the next actions that matter. Built for people who want meaningful progress in their health journey.</p>
            </div>
            <div>
              <img src="image2.jpg" srcSet="image2.jpg 800w, image2.jpg 1200w" alt="App screenshot" className="w-full rounded-image shadow-md object-cover" loading="lazy" decoding="async" width="800" height="500" />
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-white">
          <div className="site-container px-6">
            <div className="text-center">
              <h3 className="text-xl font-bold mb-2">Ready to Start Tracking?</h3>
              <p className="text-slate-600 mb-6">Begin your journey of data-driven self-improvement with our comprehensive tracking platform.</p>
              <button
                onClick={() => navigate('/more')}
                className="inline-flex items-center rounded-md bg-slate-900 px-6 py-3 text-white"
              >
                View More Trackers
              </button>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  );
};

export default TrackPage;
